
export default {
  props:{
    region:{
      type:String,
      default:'uk',
    },
  },
  data(){
    return{
      centre: this.region === 'uk' || this.region === 'IE' || this.region === 'CA' ? 'Centre' : 'Center'
    }
  },
}
